import { render, staticRenderFns } from "./ProfileSummary.vue?vue&type=template&id=0811031b&"
import script from "./ProfileSummary.vue?vue&type=script&lang=js&"
export * from "./ProfileSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports